import React, { useContext } from 'react'
import Card from './Card'
import { NavigationContext } from '../context/NavigationContext';
import MenuItem from './MenuItem';
import LinkItem from './LinkItem';

const NavigationLinks = () => {
    const { pages } = useContext(NavigationContext)

    return (
        <div>
            <h3>Liens utiles</h3>
            <Card size="medium">
                <LinkItem key="moodle" to="https://moodle.utc.fr/course/search.php?search=nf05" icon="moodle">Moodle NF05</LinkItem>
                <LinkItem key="pix" to="https://pix.fr/" icon="pix">Site de Pix</LinkItem>
                <LinkItem key="utc" to="https://www.utc.fr" icon="utc">Site de l'UTC</LinkItem>
            </Card>
        </div>
    );
}

export default NavigationLinks;